export default {
  'storyHero.label': 'Brand Story',
  'storyHero.title': '让数据',
  'storyHero.titleAccent': '回归核心',
  'storyHero.description': '在几何学中，轴心是旋转的基础，是力量的来源。在数字世界中，AX Axis 致力于成为每个人、每个家庭、每家企业的「数字旋转轴心」。',
  'storyHero.bottomLine': 'DATA RETURNS TO THE AXIS',

  'storyContent.ch1.label': '序章',
  'storyContent.ch1.title': '失控的数字云端',
  'storyContent.ch1.body.0': '在二十一世纪的第三个十年，人类生活在一个吊诡的时代。',
  'storyContent.ch1.body.1': '我们所有的记忆——照片、文档、通讯纪录、甚至是深夜的突发奇想——都被装载进无形的「云端」。这些数据漂浮在由科技巨头掌控的服务器中。我们在享受便利的同时，却也交出了数据的物理掌控权。数据泄露、算法窥视、服务中断，让这朵「云」变得沈重且不可捉摸。',
  'storyContent.ch1.body.2': '这是一个数据主权逐渐失控的时代，而这正是 AX Axis 故事的起点。',

  'storyContent.ch2.label': '转折',
  'storyContent.ch2.title': '轴心的诞生',
  'storyContent.ch2.body.0': '「为什么我们最珍贵的数字资产，不能像实体存折一样，安全地锁在自己的抽屉里？」',
  'storyContent.ch2.body.1': '这个问题，让在香港深耕多年的系统架构师与在大湾区拥有极致工艺追求的硬件工程师走到了一起。香港的国际视野赋予了我们對数据安全标准的偏执，而内地的强大供应链则让这种偏执得以具现化。',
  'storyContent.ch2.body.2': '我们决定打破传统 NAS（网络附属存储）繁琐、笨重的刻板印象。',
  'storyContent.ch2.body.3': '我们将品牌命名为 Axis（轴心）。在几何学中，轴心是旋转的基础，是力量的来源。在数字世界中，AX Axis 致力于成为每个人、每个家庭、每家企业的「数字旋转轴心」。',

  'storyContent.ch3.label': '碰撞',
  'storyContent.ch3.title': '技术与美学的碰撞',
  'storyContent.ch3.body.0': '我们不满足于仅仅做一个存储器。',
  'storyContent.ch3.body.1': 'Axis OS 的灵魂：我们花费数千个日夜，从底层内核开始重写，只为了解決一个痛点：如何在保证绝对私密的前提下，实现流畅如本地磁盘的远程访问。',
  'storyContent.ch3.body.2': '特斯拉式的工业哲学：我们拒绝廉价的塑料感。每一台 Axis Hub 都要经历数十道阳极氧化工序，采用一体成型的铝合金机身。我们相信，守护数据的设备本身，就应该像一件艺术品。',

  'storyContent.ch4.label': '愿景',
  'storyContent.ch4.title': '让数据回归核心',
  'storyContent.ch4.body.0': '今天，AX Axis 不仅仅是一家香港研发、全球交付的科技公司，我们更是一场关于「数字自主」的运动。',
  'storyContent.ch4.body.1': '当你打开手机，瞬时加载出家中硬盘里的 4K 影片；当你身在纽约，却能毫无延迟地读取香港办公室的设计草稿；当你不再收到精准得令人恐惧的广告推送，因为你的行为数据从未离开过你的书房……',
  'storyContent.ch4.body.2': '那一刻，你会明白 AX Axis 的意义。',
  'storyContent.ch4.body.3': '让数据，回归核心。让主权，回归于你。',

  'storyValues.label': 'Core Values',
  'storyValues.title': '品牌价值观',
  'storyValues.subtitle': '四大基石，构建 AX Axis 的数字自主信念体系',
  'storyValues.value1.title': '物理安全',
  'storyValues.value1.en': 'Physicality',
  'storyValues.value1.desc': '看得见、摸得着的数据，才是真正安全的数据。',
  'storyValues.value2.title': '极致速度',
  'storyValues.value2.en': 'Performance',
  'storyValues.value2.desc': '技术不应成为创造力的绊脚石。',
  'storyValues.value3.title': '隐私主权',
  'storyValues.value3.en': 'Sovereignty',
  'storyValues.value3.desc': '拒绝数据采集，守护数字世界的最后一公里。',
  'storyValues.value4.title': '简约美学',
  'storyValues.value4.en': 'Minimalism',
  'storyValues.value4.desc': '繁杂交给底层系统，极简留给用户体验。',
};